import UploadMacAddressImage from './UploadMacAddressImage';

export default UploadMacAddressImage;
